import type { FC, ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

import './no-results.scss'

const NoResults: FC<{ children?: ReactNode; className?: string }> = ({
  children = 'No results',
  className,
}) => <div className={twMerge('no-results', className)}>{children}</div>

export default NoResults
